module.exports = __webpack_public_path__ + "img/phone.af40e83f.svg";